import { render, staticRenderFns } from "./VipOrdersTable.vue?vue&type=template&id=afa75cb8&scoped=true"
import script from "./VipOrdersTable.vue?vue&type=script&lang=js"
export * from "./VipOrdersTable.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./VipOrdersTable.vue?vue&type=style&index=1&id=afa75cb8&prod&lang=css"
import style2 from "./VipOrdersTable.vue?vue&type=style&index=2&id=afa75cb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa75cb8",
  null
  
)

export default component.exports